module.exports = __webpack_public_path__ + "img/oneClickBeautyTransformation02.f8aae6c4.png";